<section class="faq-page">

  <div class="faq-bg">
    <div class="blob blob-1"></div>
    <div class="blob blob-2"></div>
  </div>

  <!-- Sticky Header -->
  <header class="faq-header">
    <div class="section-heading">
      <u>&nbsp;&nbsp;Frequently</u>&nbsp;<u>Asked</u><u> Questions&nbsp;&nbsp;</u>
    </div>
    <p class="faq-subtitle">
      Find answers to common questions grouped by category
    </p>
    <div class="faq-chips">
      <button
        class="chip"
        *ngFor="let group of groupedFaqs"
        (click)="scrollToCategory(group.categoryId)"
      >
        {{ group.categoryName }}
      </button>
    </div>
  </header>

  <!-- Scrollable Content -->
  <div class="faq-scroll" #faqScroll (scroll)="onScroll()">
    <div *ngIf="groupedFaqs.length; else noFaqs" class="faq-container">
      <section
        class="faq-category"
        [attr.id]="'faq-' + group.categoryId"
        *ngFor="let group of groupedFaqs; trackBy: trackByCategory"
      >
        <h3 class="category-title">{{ group.categoryName }}</h3>

        <mat-accordion multi>
          <mat-expansion-panel
            *ngFor="let faq of group.faqs; trackBy: trackByFaq"
            class="faq-panel"
          >
            <mat-expansion-panel-header>
              <mat-panel-title class="faq-question">
                {{ faq.question }}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="faq-answer" [innerHTML]="faq.answer"></div>
          </mat-expansion-panel>
        </mat-accordion>
      </section>
    </div>

    <ng-template #noFaqs>
      <div class="no-faqs">
        <mat-icon>help_outline</mat-icon>
        <p>No FAQs available at the moment.</p>
      </div>
    </ng-template>
  </div>

  <div class="scroll-hint" *ngIf="!hasScrolled">
    <mat-icon>keyboard_arrow_down</mat-icon>
  </div>

</section>